'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash.throttle');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  holder: {
    position: 'relative',
    display: 'inline-block'
  },
  overlayHolder: {
    position: 'relative',
    display: 'block'
  },
  overlay: {
    position: 'absolute',
    left: 0,
    top: 10,
    borderRadius: 5,
    border: '1px solid #fff'
  },
  overlayMobile: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    height: '100%',
    zIndex: 5000
  },
  overlayMobileBackground: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    background: 'rgba(0%, 0%, 0%, .75)',
    zIndex: 1
  },
  overlayMobileHolder: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2
  },
  overlayMobileHolderInner: {
    position: 'relative',
    border: '1px solid #fff',
    backgroundColor: '#fff',
    borderRadius: 5,
    zIndex: 3
  },
  arrow: {
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    width: 0,
    height: 0,
    marginLeft: -10,
    border: 'solid transparent',
    pointerEvents: 'none',
    borderColor: 'rgba(136, 183, 213, 0)',
    borderBottomColor: '#fff',
    borderWidth: 10
  },
  overlayCrossLeft: {
    width: 1,
    backgroundColor: '#fff',
    height: 20,
    position: 'absolute',
    top: 10,
    right: 20,
    transform: 'rotate(45deg)'
  },
  overlayCrossRight: {
    width: 1,
    backgroundColor: '#fff',
    height: 20,
    position: 'absolute',
    top: 10,
    right: 20,
    transform: 'rotate(-45deg)'
  }
};

var POSITION_LEFT = 'left';
var POSITION_RIGHT = 'right';
var POSITION_CENTER = 'center';

var ResponsiveDropdown = function (_Component) {
  (0, _inherits3.default)(ResponsiveDropdown, _Component);

  function ResponsiveDropdown(props) {
    (0, _classCallCheck3.default)(this, ResponsiveDropdown);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ResponsiveDropdown.__proto__ || (0, _getPrototypeOf2.default)(ResponsiveDropdown)).call(this, props));

    _this.onWindowClick = function (event) {
      if (_this.refs.root && _this.props.visible && _this.visible) {
        var domNode = _this.refs.root;
        if (event.target !== domNode && !domNode.contains(event.target) && _this.props.hideOnOutsideClick) {
          _this.handleClickOverlay();
        }
      }
    };

    _this.onResize = function (event) {
      (0, _lodash2.default)(function () {
        _this.getSize();
      }, 500);
    };

    _this.handleClickOverlay = function () {
      _this.props.clickOverlay && _this.props.clickOverlay();
    };

    _this.state = {
      position: {},
      size: {}
    };
    return _this;
  }

  (0, _createClass3.default)(ResponsiveDropdown, [{
    key: 'getPlacement',
    value: function getPlacement() {
      var _state = this.state,
          element = _state.element,
          size = _state.size;
      var width = this.props.width;

      if (element.x < width / 2) {
        return POSITION_LEFT;
      }
      if (element.x + width > size.width) {
        return POSITION_RIGHT;
      }
      return POSITION_CENTER;
    }
  }, {
    key: 'styleForOverlay',
    value: function styleForOverlay() {
      var size = this.state.size;
      var _props = this.props,
          width = _props.width,
          backgroundColor = _props.backgroundColor,
          borderColor = _props.borderColor,
          borderRadius = _props.borderRadius,
          borderWidth = _props.borderWidth,
          arrowSize = _props.arrowSize;

      if (this.isMobile()) {
        return (0, _assign2.default)({}, styles.overlayMobile, { height: size.height });
      }
      var baseProps = (0, _assign2.default)({}, styles.overlay, {
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderRadius: borderRadius,
        borderWidth: borderWidth,
        top: arrowSize + borderWidth
      });
      switch (this.getPlacement()) {
        case POSITION_LEFT:
          return (0, _assign2.default)({}, baseProps, {
            width: width,
            left: 0
          });
        case POSITION_RIGHT:
          return (0, _assign2.default)({}, baseProps, {
            width: width,
            left: 'auto',
            right: 0
          });
        default:
          return (0, _assign2.default)({}, baseProps, {
            width: width,
            left: '50%',
            marginLeft: '-' + parseInt(width / 2, 10) + 'px'
          });
      }
    }
  }, {
    key: 'styleForArrow',
    value: function styleForArrow() {
      var element = this.state.element;
      var _props2 = this.props,
          borderColor = _props2.borderColor,
          borderWidth = _props2.borderWidth,
          arrowSize = _props2.arrowSize;

      var baseProps = (0, _assign2.default)({}, styles.arrow, {
        borderBottomColor: borderColor,
        borderWidth: arrowSize + borderWidth + 1,
        marginTop: borderWidth * -1,
        marginLeft: (arrowSize + borderWidth + borderWidth + 1) * -1
      });
      switch (this.getPlacement()) {
        case POSITION_LEFT:
          return (0, _assign2.default)({}, baseProps, {
            left: parseInt(element.width / 2, 10)
          });
        case POSITION_RIGHT:
          return (0, _assign2.default)({}, baseProps, {
            left: 'auto',
            marginRight: baseProps.marginLeft,
            right: parseInt(element.width / 2, 10)
          });
        default:
          return (0, _assign2.default)({}, baseProps);
      }
    }
  }, {
    key: 'styleForArrowInner',
    value: function styleForArrowInner() {
      var element = this.state.element;
      var _props3 = this.props,
          backgroundColor = _props3.backgroundColor,
          borderWidth = _props3.borderWidth,
          arrowSize = _props3.arrowSize;

      var baseProps = (0, _assign2.default)({}, styles.arrow, {
        borderBottomColor: backgroundColor,
        marginTop: -1,
        borderWidth: arrowSize,
        marginLeft: (arrowSize + borderWidth) * -1
      });
      switch (this.getPlacement()) {
        case POSITION_LEFT:
          return (0, _assign2.default)({}, baseProps, {
            left: parseInt(element.width / 2, 10)
          });
        case POSITION_RIGHT:
          return (0, _assign2.default)({}, baseProps, {
            left: 'auto',
            marginRight: baseProps.marginLeft,
            right: parseInt(element.width / 2, 10)
          });
        default:
          return (0, _assign2.default)({}, baseProps);
      }
    }
  }, {
    key: 'styleForInner',
    value: function styleForInner() {
      var size = this.state.size;
      var _props4 = this.props,
          width = _props4.width,
          backgroundColor = _props4.backgroundColor,
          borderColor = _props4.borderColor,
          borderWidth = _props4.borderWidth;

      return (0, _assign2.default)({}, styles.overlayMobileHolderInner, {
        width: Math.min(width, size.width),
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderWidth: borderWidth
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getPosition();
      global.addEventListener('resize', this.onResize);
      global.addEventListener('click', this.onWindowClick);
      this.visible = this.props.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      global.removeEventListener('resize', this.onResize);
      global.removeEventListener('click', this.onWindowClick);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (this.props.visible !== prevProps.visible || this.props.cacheKey !== prevProps.cacheKey) {
        this.getPosition();
      }
      setTimeout(function () {
        _this2.visible = _this2.props.visible;
      });
    }
  }, {
    key: 'getPosition',
    value: function getPosition() {
      if (this.refs.root) {
        var domNode = this.refs.root;
        this.setState({
          element: {
            x: domNode.offsetLeft,
            y: domNode.offsetTop,
            width: domNode.offsetWidth,
            height: domNode.offsetHeight
          },
          size: this.getSize(true)
        });
      }
    }
  }, {
    key: 'getSize',
    value: function getSize() {
      var onlyReturn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.refs.root) {
        var _state$size = this.state.size,
            width = _state$size.width,
            height = _state$size.height;
        var _global = global,
            innerWidth = _global.innerWidth,
            innerHeight = _global.innerHeight;

        var newSize = {
          width: innerWidth,
          height: innerHeight
        };
        if (onlyReturn) {
          return newSize;
        }
        if (width !== innerWidth || height !== innerHeight) {
          this.setState({ size: newSize });
        }
      }
    }
  }, {
    key: 'isMobile',
    value: function isMobile() {
      var _props5 = this.props,
          width = _props5.width,
          breakpoint = _props5.breakpoint;
      var size = this.state.size;

      return size.width < breakpoint || width > size.width;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          children = _props6.children,
          dropdownView = _props6.dropdownView,
          visible = _props6.visible;

      if (!visible) {
        return _react2.default.Children.only(this.props.children);
      } else {
        var element = this.state.element;

        return _react2.default.createElement(
          'div',
          { ref: 'root', style: styles.holder },
          children,
          element && _react2.default.createElement(
            'div',
            { style: styles.overlayHolder },
            _react2.default.createElement(
              'div',
              { style: this.styleForOverlay() },
              this.isMobile() && _react2.default.createElement(
                'div',
                { style: styles.overlayMobileHolder },
                _react2.default.createElement(
                  'div',
                  { style: styles.overlayMobileBackground, onClick: this.handleClickOverlay },
                  _react2.default.createElement('div', { style: styles.overlayCrossLeft }),
                  _react2.default.createElement('div', { style: styles.overlayCrossRight })
                ),
                _react2.default.createElement(
                  'div',
                  { style: this.styleForInner() },
                  dropdownView
                )
              ),
              !this.isMobile() && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { style: this.styleForArrow() }),
                _react2.default.createElement('div', { style: this.styleForArrowInner() }),
                dropdownView
              )
            )
          )
        );
      }
    }
  }]);
  return ResponsiveDropdown;
}(_react.Component);

ResponsiveDropdown.defaultProps = {
  width: 200,
  breakpoint: 500,
  cacheKey: 'hello world',
  backgroundColor: '#ffffff',
  borderColor: '#ffffff',
  borderRadius: 4,
  borderWidth: 1,
  arrowSize: 10,
  hideOnOutsideClick: true
};

ResponsiveDropdown.propTypes = {
  children: _react.PropTypes.any.isRequired,
  dropdownView: _react.PropTypes.element.isRequired,
  visible: _react.PropTypes.bool,
  width: _react.PropTypes.number,
  breakpoint: _react.PropTypes.number,
  cacheKey: _react.PropTypes.string,
  backgroundColor: _react.PropTypes.string,
  borderColor: _react.PropTypes.string,
  clickOverlay: _react.PropTypes.func,
  borderRadius: _react.PropTypes.number,
  borderWidth: _react.PropTypes.number,
  arrowSize: _react.PropTypes.number,
  hideOnOutsideClick: _react.PropTypes.bool
};

exports.default = ResponsiveDropdown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/~/react-responsive-dropdown/lib/ResponsiveDropdown.js
// module id = 699
// module chunks = 0